import { X } from "lucide-react";
import { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import toast from "react-hot-toast";

export default function PcToggle() {
  const [storedUser, setStoredUser] = useState(null);
  const [user, setUser] = useState(() => {
    return storedUser !== "null" && storedUser ? storedUser : null;
  });
  const [key, setKey] = useState(() => localStorage.getItem("key") || null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [inputKey, setInputKey] = useState("");
  const [logoutConfirm, setLogoutConfirm] = useState(false);

  const validKeys = {
    "PC - 1": "pc123",
    "PC - 2": "pc456",
    "PC - 3": "pc789",
  };

  const verifyKey = () => {
    const selectedUser = Object.keys(validKeys).find(
      (pc) => validKeys[pc] === inputKey,
    );
    if (selectedUser) {
      toast.success(`Access granted for ${selectedUser}`);
      setUser(selectedUser);
      setKey(inputKey);
      localStorage.setItem("user", selectedUser);
      localStorage.setItem("key", inputKey);
    } else {
      toast.error("Invalid key! Please try again.");
    }
    setDialogOpen(false);
    setInputKey("");
  };

  const pcLogout = () => {
    setLogoutConfirm(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("key");
    setUser(null);
    setKey(null);
    // toast.success("Logged out successfully!");
    setLogoutConfirm(false);
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    setStoredUser(user);
  }, []);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedKey = localStorage.getItem("key");
    if (
      storedUser &&
      storedKey &&
      storedUser !== "null" &&
      storedKey !== "null"
    ) {
      setUser(storedUser);
      setKey(storedKey);
    }
  }, []);

  return (
    <>
      <div className="p-0 border-0 rounded text-center border-secondary">
        {user && key ? (
          <>
            {/* <div className="fw-semibold">{user}</div> */}
            <div className="mt-0">
              <Button variant="danger" className="w-100" onClick={pcLogout}>
                {user}
              </Button>
            </div>
          </>
        ) : (
          <Button
            variant="primary"
            className="w-100"
            onClick={() => setDialogOpen(true)}
          >
            Enter PC Key
          </Button>
        )}
      </div>

      {/* Key Input Modal */}
      <Modal show={dialogOpen} onHide={() => setDialogOpen(false)} centered>
        <div
          style={{
            background: "var(--card-bg)",
            color: "var(--text)",
            borderRadius: "9px",
          }}
        >
          <Modal.Header className="d-flex justify-content-between">
            <Modal.Title>Enter PC Key</Modal.Title>
            <button
              className="close-btn"
              onClick={() => setDialogOpen(false)}
            >
              <X />
            </button>
          </Modal.Header>
          <Modal.Body className="border-0">
            <Form.Control
              type="password"
              placeholder="Enter key"
              value={inputKey}
              onChange={(e) => setInputKey(e.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDialogOpen(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={verifyKey}>
              Verify
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      {/* Logout Confirmation Modal */}
      <Modal
        show={logoutConfirm}
        onHide={() => setLogoutConfirm(false)}
        centered
      >
        <div
          style={{
            background: "var(--card-bg)",
            color: "var(--text)",
            borderRadius: "9px",
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Logout</Modal.Title>
          </Modal.Header>
          <Modal.Body className="subtitle">
            Are you sure you want to change?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setLogoutConfirm(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmLogout}>
              Change
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
}
